<section >
    <header class="row page-header">
        <div class="col-sm-12">
            <div class="controls pull-right">
                <ng-container *ngIf="(filter$ | async) as filter">
                    <button class="btn btn-link" type="submit" (click)="onExport(filter)">
                        <i class="fa-regular fa-file-excel" aria-hidden="true"></i> Export to Excel
                    </button>
                </ng-container>
                <ng-container>
                    <button class="btn btn-toggle btn-toggle-no-shadow" [ngClass]="{'selected': showFilter}" (click)="onHideShowFilter()"><i class="fa fa-filter" aria-hidden="true"></i> Filters</button>
                </ng-container>
            </div>
        </div>
    </header>

    <main>
        <sp-activity-report-display
            *ngIf="activityReport$ | async"
            [activityReport]="activityReport$ | async"
            [activityReportFilter]="filter$ | async"
            [showFilter]="showFilter"
            (filterChanged)="onFilterChanged($event)"
            (pageChanged)="onPageChanged($event)"
            (viewComponentDetails)="onViewComponentDetails($event)"
            (viewProjectDetails)="onViewProjectDetails($event)"
            (hideFilter)="onHideShowFilter()">
        </sp-activity-report-display>
    </main>
</section>
